import { PREDICTIONS_API_ENDPOINTS } from "@/features/predictions/config/predictionsApiPath";
import {
  fromPreferencePatch,
  toMyPronosticsPreferences,
} from "@/features/predictions/services/mappers";
import type {
  ApiMyPronosticsPreferences,
  MyPronosticsPreferences,
  PreferencePatch,
} from "@/features/predictions/types/preferences.type";
import { fetcher } from "@/shared/lib/fetcher.client";

export const preferencesService = {
  async getMyPreferences(): Promise<MyPronosticsPreferences> {
    const response = await fetcher.get<{ preferences: ApiMyPronosticsPreferences }>(
      PREDICTIONS_API_ENDPOINTS.ME_PREFERENCES,
    );
    return toMyPronosticsPreferences(response.data.preferences);
  },

  async updatePreferences(patch: PreferencePatch): Promise<MyPronosticsPreferences> {
    const response = await fetcher.patch<{ preferences: ApiMyPronosticsPreferences }>(
      PREDICTIONS_API_ENDPOINTS.ME_PREFERENCES,
      fromPreferencePatch(patch),
    );
    return toMyPronosticsPreferences(response.data.preferences);
  },

  async leaveCompetition(): Promise<MyPronosticsPreferences> {
    const response = await fetcher.post<{ preferences: ApiMyPronosticsPreferences }>(
      PREDICTIONS_API_ENDPOINTS.ME_LEAVE,
    );
    return toMyPronosticsPreferences(response.data.preferences);
  },

  async joinCompetition(): Promise<MyPronosticsPreferences> {
    const response = await fetcher.post<{ preferences: ApiMyPronosticsPreferences }>(
      PREDICTIONS_API_ENDPOINTS.ME_JOIN,
    );
    return toMyPronosticsPreferences(response.data.preferences);
  },
};
